export default __webpack_public_path__ + "static/media/wallet-icon.99d57663.svg";